import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppState } from '../models/app-state.models';
import { Store, select } from '@ngrx/store';

import { Endpoints } from '../models/endpoints.models';

@Injectable({ providedIn: 'root' })
export class APIService {

    private endpoints;

    constructor(
        private httpClient: HttpClient,
        private store: Store<AppState>
    ) {
        
    }

    public get(api, queryParams = {}, urlParams = {}): Observable<any> {
        let url = this.getUrl(api, queryParams);
        url = this.updateUrlParams(url, urlParams);
        return this.httpClient.get(url);
    }

    public post(api, data, queryParams = {}, urlParams = {}): Observable<any> {
/*         let url = this.getUrl(api, queryParams);
        url = this.updateUrlParams(url, urlParams); */
        return this.httpClient.post(api, data);
    }

    public patch(api, data, queryParams = {}, urlParams = {}): Observable<any> {
        let url = this.getUrl(api, queryParams);
        url = this.updateUrlParams(url, urlParams);
        return this.httpClient.patch(url, data);
    }

    public delete(api, queryParams = {}, urlParams = {}): Observable<any> {
        let url = this.getUrl(api, queryParams);
        url = this.updateUrlParams(url, urlParams);
        return this.httpClient.delete(url);
    }

    public put(api, data, queryParams = {}, urlParams = {}): Observable<any> {
        let url = this.getUrl(api, queryParams);
        url = this.updateUrlParams(url, urlParams);
        return this.httpClient.put(url, data, {
            reportProgress: true,
            observe: 'events'
        });
    }

    public fileUpload(url, data, headers): Observable<any> {
        return this.httpClient.put(url, data, {
            // headers: new HttpHeaders(headers),
            headers: new HttpHeaders({
                disableauthintercept: "true"
            }),
            reportProgress: true,
            observe: 'events',
        });
    }

    private getUrl(api, queryParams = {}) {        
        let url = this.endpoints[api];
        if (!url) {
            console.error('API endpoint is not defined:', api);
            return false;
        }
        if (Object.keys(queryParams).length > 0) {
            url = url + '?' + this.objToQueryString(queryParams);
        }
        
        return url;
    }

    public objToQueryString(params) {
        const queryString = Object.keys(params).map(key => {
            if (params[key]) {
                return key + '=' + params[key];
            }
        }).join('&');
        return queryString;
    }

    private updateUrlParams(url, params = {}) {
        if (params) {
            Object.keys(params).forEach(param => {
                url = url.replace(`{{${param}}}`, params[param])
            })
        }
        return url;
    }

}

